import api from 'Application/api/api';

const signatureConfirmSuccessfulCheckForDirectProcedure = (
    driverLicenseControlId,
    signature,
    cancelToken = null,
) => {
    const formData = new FormData();

    formData.append('signature', signature);

    return api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/direct-check/signature-confirm-successful-check`,
        formData,
        { cancelToken },
    );
};

export default signatureConfirmSuccessfulCheckForDirectProcedure;
